// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__291lr","row":"Node_row__FVQ4j","label":"Node_label__39y25","footer":"Node_footer__2jmYK"};